import { render, staticRenderFns } from "./ThinkingView.vue?vue&type=template&id=11a5a149&scoped=true&"
import script from "./ThinkingView.vue?vue&type=script&lang=js&"
export * from "./ThinkingView.vue?vue&type=script&lang=js&"
import style0 from "./ThinkingView.vue?vue&type=style&index=0&id=11a5a149&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a5a149",
  null
  
)

export default component.exports